import React from 'react';
import { Modal } from '@mui/material';
import LinearLoader from '../../cosmetics/linearLoader/LinearLoader';
import './CopyModal.scss';
const CopyModal = ({ open, text }) => (React.createElement("div", null,
    React.createElement(Modal, { open: open, className: "copy-modal" },
        React.createElement("div", { className: "copy-modal-container" },
            React.createElement("p", null, text),
            React.createElement(LinearLoader, null)))));
export default CopyModal;
